import { SUPERSCRIPT } from '@/Scripts/constants';
export default {
  convert (str) {
    const keys = Object.keys(SUPERSCRIPT);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const val = SUPERSCRIPT[key];
      const regex = new RegExp(`\\b${key}`, 'ig');
      if (regex.test(str.toLowerCase())) {
        let supkey = key.replace(val, `<sup>${val}</sup>`);
        supkey = `<span class="-lower">${supkey}</span>`;
        // replace non-case sensitive
        str = str.replace(regex, supkey);
      }
    }
    return str;
  }

};
